function getUrlVars(path) {
    var vars = {};
    var parts = path.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}

export default getUrlVars;